import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import HoverVideoPlayer from "react-hover-video-player";
import { StyledMarketplaceDesignCard } from "../styled/styles";
import {
  MarketplaceTemplatesAction,
  StoryCardCoverImage,
  TldrProgressDialog,
} from "../common/statelessView";
import { cloneTemplate } from "../../_actions/storiesActions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import TldrGuidedTour from "../partners/TldrGuidedTour";
import { redirect } from "../../_actions/commonAction";
import { STORY_DETAIL } from "../../_utils/routes";
import Format from "string-format";
import { analyticsTrackEvent } from "../../_utils/common";
import {
  API_DEBOUNCE_TIME,
  NO_ACCESS_TO_CREATE_STORY,
  StoryTypes,
} from "../../_utils/constants";
import { debounce } from "lodash";
import { FaPlay, FaPlusCircle } from "react-icons/fa";
import { showToast } from "../../_utils/showToast";
import { withTranslation } from "react-i18next";

export class DesignCard extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.state = {
      isHovering: false,
      inProgress: false,
      showCloneModal: false,
      startGuidedTour: false,
      showUpgradeSubscriptionModal: false,
    };
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleMouseEnter() {
    this.setState({
      isHovering: true,
    });
  }

  handleMouseLeave() {
    this.setState({
      isHovering: false,
    });
  }

  toggleHoverState(state) {
    return {
      isHovering: !state.isHovering,
    };
  }

  onClick = debounce(() => {
    const { story, workspacePermissionChecks, t } = this.props;
    const { canCreateStory } = workspacePermissionChecks;
    if (!canCreateStory) {
      showToast({
        description: NO_ACCESS_TO_CREATE_STORY,
        title: t("limited_access", { ns: "common" }),
        status: "info",
      });
      return;
    }
    const isGuidedTemplate = story.tags.includes("shopify");
    if (isGuidedTemplate) {
      this.setState({
        startGuidedTour: true,
      });
    } else {
      this.setState({
        inProgress: true,
        showCloneModal: true,
      });
      this.props
        .cloneTemplate(this.props.story.id, this.signal, this.props, true)
        .then(() => {
          this.setState({
            inProgress: false,
            showCloneModal: false,
          });
        });
      analyticsTrackEvent("cloneTemplate", {
        template: this.props.story.id,
      });
    }
  }, API_DEBOUNCE_TIME);

  render() {
    const { inProgress, showCloneModal, startGuidedTour } = this.state;
    const { story, showHoverOverlay, t } = this.props;
    const { id, image, image_height, image_width, title, story_type, video } =
      story;

    const hasPreviewVideo = story_type === StoryTypes.ANIMATED && video;

    return (
      <StyledMarketplaceDesignCard>
        <div
          className="design-card-thumbnail"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.onClick}
        >
          {story_type === StoryTypes.ANIMATED && (
            <div className="label-container">
              <FaPlay size="xs" />
            </div>
          )}
          {hasPreviewVideo ? (
            <HoverVideoPlayer
              crossOrigin={null}
              videoSrc={video}
              restartOnPaused
              pausedOverlay={
                <StoryCardCoverImage
                  imageSrc={image}
                  width={image_width}
                  height={image_height}
                  altTitle={title}
                  NativeImgProps={{ style: { objectFit: "cover" } }}
                />
              }
              videoStyle={{
                borderRadius: "8px",
              }}
            />
          ) : (
            <StoryCardCoverImage
              imageSrc={image}
              width={image_width}
              height={image_height}
                altTitle={title}
            />
          )}

          {this.state.isHovering && showHoverOverlay && (
            <div className="actions">
              <MarketplaceTemplatesAction
                action="clone"
                id={id}
                icon={
                  <FaPlusCircle
                    size={"2em"}
                    style={{ marginRight: "0.25rem" }}
                  />
                }
                tooltip={t("my_template.use_temp")}
                clickHandler={this.onClick}
                label={t("my_template.use_temp")}
              />
            </div>
          )}
        </div>

        <TldrProgressDialog
          inProgress={inProgress}
          show={showCloneModal}
          onHide={() => {
            this.setState({
              ...this.state,
              showCloneModal: false,
            });
          }}
          onYes={() => {
            this.setState({
              inProgress: true,
            });
          }}
        ></TldrProgressDialog>
        {startGuidedTour && (
          <TldrGuidedTour
            onComplete={(res) => {
              this.setState(
                {
                  ...this.state,
                  startGuidedTour: false,
                },
                () => {
                  this.props.redirect(
                    Format(
                      STORY_DETAIL,
                      res.data.organization,
                      res.data.id,
                      encodeURIComponent(res.data.title)
                    ),
                    this.props
                  );
                }
              );
            }}
            onHide={() => {
              this.setState({
                ...this.state,
                startGuidedTour: false,
              });
            }}
            templateId={this.props.story.id}
          ></TldrGuidedTour>
        )}
      </StyledMarketplaceDesignCard>
    );
  }
}

DesignCard.propTypes = {
  story: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.errors,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
});

const mapDispatchToProps = (dispatch) => ({
  cloneTemplate: (storyId, signal, props, openNewTab) =>
    dispatch(cloneTemplate(storyId, signal, props, openNewTab)),
  redirect: (path, props) => dispatch(redirect(path, props)),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(DesignCard))
);
